import SessionStorageManager from '../../services/SessionStorageManager'

// User to restore the checkout when returning from redirect
const SINGLE_PRODUCT_KEY = 'single-product'

// Save to session storage (and not local storage), so it will be available between redirects but will be deleted if the tab was closed
export function storeSingleProduct(singleProduct) {
  SessionStorageManager.set(SINGLE_PRODUCT_KEY, singleProduct)
}

export function restoreSingleProduct() {
  return SessionStorageManager.get(SINGLE_PRODUCT_KEY) || {}
}

export function clearSingleProduct() {
  SessionStorageManager.remove(SINGLE_PRODUCT_KEY)
}
